import type { CustomerAddress } from '../customer/customer.interface';
import { ObjectFactory } from './object.factory';

/**
 * Coordinates are deliberately omitted from the default — `CustomerAddressLocation.coordinates`
 * is required by the domain type, but real (and pre-migration legacy) documents may not have one
 * stored yet, so tests exercising that tolerant shape can build off these defaults unchanged.
 */
export class CustomerAddressFactory extends ObjectFactory<CustomerAddress> {
  protected getDefaults(): CustomerAddress {
    return {
      location: {
        address: { city: 'Paris', country: 'FR', postalCode: '75001', street: '1 Rue de la Paix' },
        isDefault: true,
      },
      originalAddress: '1 Rue de la Paix, 75001 Paris, FR',
    } as unknown as CustomerAddress;
  }
}

export const customerAddressFactory = new CustomerAddressFactory();
